<template>
    <div class="lb-comment">
        <!--<article>
            <div>
                <div>
                    <p class="is-size-6">
                        <span class="pr-1 has-text-primary secondary-font-bold">
                            {{
                                comment.owner.alias || comment.owner.username
                            }}</span
                        ><span class="is-size-7 has-text-eduloc-grey secondary-font">
                            {{ comment.modified | timeFormat }}
                        </span>
                        <span
                            v-if="comment.edited"
                            v-t="'App.content_edited'"
                            class="is-italic is-size-7 secondary-font"
                        >
                        </span>
                    </p>
                </div>
                <span
                    v-if="comment.deleted"
                    v-t="'App.comment_deleted'"
                    class="is-italic is-size-7 secondary-font"
                ></span>
            </div>
        </article>-->
        <n-app-editable-comment
            
            :commentData="comment"
            :message="comment.message"
            :editable="canEdit"
            :has-editor="hasEditor"
            :editionDisabled="editionDisabled"
            @edit="emitEdit"
            @delete="$emit('delete', $event)"
            
        />
    </div>
</template>
<script>
import moment from 'moment';
import NAppEditableComment from '@/components/NAppEditableComment';
export default {
    components: {
        NAppEditableComment,
    },
    filters: {
        timeDifference(timestamp) {
            moment.locale('es'); // TODO use vue moment to better handle this
            // console.log();
            return moment(moment(timestamp), 'minutes').fromNow();
        },
        timeFormat(timestamp) {
            return moment(timestamp).format('DD/MM/YY HH:mm');
        },
    },
    props: {
        comment: {
            type: Object,
            default: () => {
                return {};
            },
        },
        object: {
            type: Object,
            default: () => {
                return {};
            },
        },
        hasEditor: {
            type: Boolean,
            default: false,
        },
        editionDisabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        canManage() {
            return (
                (this.comment.owner.owner === this.$store.getters.user.owner ||
                    this.object.owner.owner ===
                        this.$store.getters.user.owner) &&
                !this.comment.deleted
            );
        },
        canEdit() {
            return (
                this.comment.owner.owner === this.$store.getters.user.owner &&
                !this.comment.deleted
            );
        },
    },
    methods: {
        emitEdit(message) {
            this.comment.message = message;
            this.$emit('edit', this.comment);
        },
    },
};
</script>

<style scoped>
.lb-comment {
    transition: all 0.5s;
}
</style>
